import Accounting from 'accounting'

const defaultOptions = {
  precision: 2,
  decimal: ',',
  thousand: '.',
}

export default (number, options) => {
  const config = { ...defaultOptions, ...options }
  return `${Accounting.formatNumber(number, {
    precision: config.precision,
    decimal: config.decimal,
    thousand: config.thousand,
  })} %`
}
